import { Wws_Page, Wws_PhotoAlbum } from '../../types/graphql';
import { Maybe } from 'graphql/jsutils/Maybe';
import SinglePageSection from './SinglePageSection';

interface SinglePageSectionsProps {
  isMobile: boolean;
  pages: Wws_Page[];
  photoAlbums: Maybe<Wws_PhotoAlbum[]>;
}

const shouldShowPage = (page: Wws_Page) => page && page.show && page.title;

const SinglePageSections = ({
  isMobile,
  pages,
  photoAlbums,
}: SinglePageSectionsProps) =>
  pages
    .filter(shouldShowPage)
    .map((page: Wws_Page, pageIndex) => (
      <SinglePageSection
        key={page.id}
        page={page}
        isMobile={isMobile}
        isFirstPage={pageIndex === 0}
        shouldShowTitle={page.type !== 'WeddingPage'}
        photoAlbums={photoAlbums}
      />
    ));

export default SinglePageSections;
